export default __webpack_public_path__ + "static/structure-3d3a08a7cdda4f3a758be9a2ed2d1dce.svg";